const JWT_COOKIE_NAME = "jwtToken";
const EXT_SESSIONID_COOKIE_NAME = "extSessionId";
export class CookiesStorage {
    constructor(tokenReader, cookieManager, cookiesDomain) {
        this.cookies = cookieManager;
        this.tokenReader = tokenReader;
        this.cookiesDomain = cookiesDomain;
    }
    setToken(token) {
        const expiration = this.tokenReader.tokenExpiresInDays(token);
        let cookieSettings = { expires: expiration };
        if (this.cookiesDomain) {
            cookieSettings["domain"] = this.cookiesDomain;
        }
        this.cookies.set(JWT_COOKIE_NAME, token, cookieSettings);
    }
    getToken() {
        return this.cookies.get(JWT_COOKIE_NAME);
    }
    getExtSessionId() {
        return this.cookies.get(EXT_SESSIONID_COOKIE_NAME);
    }
    setExtSessionId(extSessionId) {
        if (extSessionId) {
            this.cookies.set(EXT_SESSIONID_COOKIE_NAME, extSessionId);
            return;
        }
        return undefined;
    }
    removeExtSessionId() {
        this.cookies.set(EXT_SESSIONID_COOKIE_NAME, "", { expires: -1 });
    }
}
//# sourceMappingURL=CookiesStorage.js.map